import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';import { EditPhotoComponent } from '../../../../shared/components/edit-photo/edit-photo.component';
import { RopeShovelService } from '../../rope-shovel.service';
import { ViewPhotoComponent } from '../view-photo/view-photo.component';
import { MeasurementPointPhotoModel } from '../../models/rope-shovel.model';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'component-photo-small',
  templateUrl: './component-photo-small.component.html',
  styleUrls: ['./component-photo-small.component.scss']
})
export class ComponentPhotoSmallComponent implements OnInit {
  @Input() photoId: number;
  photo: string = "";
  title: string;
  comment: string;

  constructor(private _sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private _service: RopeShovelService,
    private _notify: NotificationsService) { }

  ngOnInit() {
    this.loadPhoto();
  }

  loadPhoto() {
    this._service.getMeasurementPointPhotoThumbnail(this.photoId).subscribe(r => {
      this.photo = r.Photo;
      this.title = r.Title;
      this.comment = r.Comment;
    });
  }

  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }

  viewPhoto() {
    let viewPhotoModalRef = this.dialog.open(ViewPhotoComponent, {
      width: '80%',
      height: '80%',
      data: { photoType: 'measurementpoint', photoId: this.photoId }
    });
    viewPhotoModalRef.afterClosed().subscribe(r => {
        if ((r.data != null) && (r.data.isDeleted))
        {
            this.photo = '';
        }
        else 
        {
            this.loadPhoto();
        }
    });
  }
}
